<template>
	<div>
		<!-- Delete dialog -->
		<v-dialog v-model="deleteDialog" width="400">
			<v-card>
				<v-card-title>
					Delete leave
				</v-card-title>
				<v-card-text>
					Are you sure you want to delete this leave ?
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						color="alert-color white--text"
						class="rounded-lg text-none"
						:loading="submitLoading"
						@click="deleteLeave()"
					>
						Yes
					</v-btn>
					<v-btn
						@click="deleteDialog = false"
						class="rounded-lg text-none"
						:disabled="submitLoading"
					>
						No
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!--  -->
		<v-row class="my-1" align="center">
			<v-col class="py-1" md="2" sm="4" > 
				<v-autocomplete
					v-model="selectedEmployeeId"
					:items="employees"
					:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee.arabicLastName}`"
					item-value="id"
					label="Employee"
					dense
					hide-details
					@input="fetchEmployeeDetails"
					clearable
					solo
					:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
					class="input"
					:loading="loading"
				></v-autocomplete> 
			</v-col>

			<v-col class="py-1" md="2" sm="4" cols="12">
				<bee-date-picker
					v-model="fromDate"
					:input-label="formattedLabel"
					elevation="2"
					menu-picker
					hide-details
					:input-props="{
						outlined: false,
						filled: false,
						dense: true,
						clearable: true
					}"
					:loading="loading"
				></bee-date-picker>
			</v-col>

			<v-col class="py-1" md="2" sm="4" cols="12" >
				<bee-date-picker
					v-model="toDate"
					:input-label="formattedToDateLabel"
					elevation="2"
					menu-picker
					hide-details
					:input-props="{
						dense: true,
						clearable: true
					}"
					solo
					:loading="loading"
				></bee-date-picker>
			</v-col>
			<v-spacer />
			<v-col class="d-flex justify-end">
				<v-btn
					@click="needResetShownRows = true; fetchAll()"
					color="dark-blue white--text"
					:loading="loading"
					class="mx-2 rounded-lg text-none"
				>
					Search
				</v-btn>

				<v-btn
					@click="needResetShownRows = true; fromDate = null; toDate = null; selectedEmployeeId = null; fetchAll()"
					color="alert-color white--text"
					:disabled="loading"
					class="mx-2 rounded-lg text-none"
				>
					Reset
				</v-btn>
			</v-col>
		</v-row>
		<!-- first card -->
		<v-card class="d-flex align-center">
			<v-card-text class="d-flex align-center">
				<v-row>
					<v-col cols="auto" >
						<div class="d-flex justify-center ml-3">
							<div class="d-flex justify-center align-center">
								<v-img
									src="../../assets/Leaves/calendar-pen 1.svg"
									width="20"
								/>
							</div>
							<div class="d-flex flex-column mx-3">
								<span class="font-weight-bold text-body-1 edit-color--text">
									{{ statics.allRequestCount }}
								</span>
								<span class="font-weight-medium text-subtitle-2" >All Requests</span>
							</div>
						</div>
					</v-col>
					<v-col cols="auto">
						<div class="d-flex justify-center ml-3">
							<div class="d-flex justify-center align-center">
								<v-img
									src="../../assets/Leaves/daily-calendar.svg"
									width="20"
								/>
							</div>
							<div class="d-flex flex-column mx-3">
								<span class="font-weight-bold text-body-1 purple--text">
									{{ statics.manyDaysRequest }}
								</span>
								<span class="font-weight-medium text-subtitle-2">Many Days Requests</span>
							</div>
						</div>
					</v-col>
					<v-col cols="auto">
						<div class="d-flex justify-center ml-3">
							<div class="d-flex justify-center align-center">
								<v-img
									src="../../assets/Leaves/calendar-clock.svg"
									width="20"
								/>
							</div>
							<div class="d-flex flex-column mx-3">
								<span class="font-weight-bold text-body-1 cyan--text">{{ statics.hourlyRequest }}</span>
								<span class="font-weight-medium text-subtitle-2" >Hourly Requests</span>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
		<div class="mt-4">
			<bee-handy-table
				ref="table"
				:headers="headers"
				:items="[]"
				:items-per-page="20"
				class="elevation-1"
				hide-default-footer
				:height="$vuetify.breakpoint.height - 250"
				dense
				zebra
				pagination-on-scroll
				pagination-on-scroll-server-items
				:options-scroll.sync="optionsScroll"
				:pagination-on-scroll-auto-reset-shown="false"
				:server-items-length="serverItemsLength"
				@pagination-on-scroll:reach-last-row="fetchAll"
				table-class="elevation-0"
				:loading="loading"
				fixed-header="true"
			>
				<template v-slot:item.supervisorAcceptance="{ item }">
					<v-chip
						:class="{
							'chip-accepted green--text font-weight-bold': item.supervisorAcceptance, 
							'chip-rejected red--text font-weight-bold': !item.supervisorAcceptance
						}"
						small
					>
						{{ item.supervisorAcceptance ? 'Acceptance' : 'Rejected' }}
					</v-chip>  
					{{ item.supervisorComment }}
				</template>

				<template v-slot:item.status="{ item }">
					<div class="d-flex">
					<!-- v-if="item.status !== statusLeaves.pending" -->
						<!-- v-if="item.status !== statusLeaves.pending" -->
					<v-chip
						v-if="(myData.isSupervisor && item.managerAcceptance === null && item.supervisorAccept !== null) || item.status !== statusLeaves.pending"
						:class="{
							'chip-accepted green--text font-weight-bold': item.status === 1, 
							'chip-rejected red--text font-weight-bold': item.status === 2,
							'yellow lighten-5 amber--text text--accent-4': item.status === 0
						}"
						small
					>
						{{ item.status === 1 ? 'Acceptance' : item.status === 2 ? 'Rejected' : 'Pending' }}
					</v-chip>  

					<div 
						v-if="
							(myData.isSupervisor && item.managerAcceptance === null && item.supervisorAccept === null) || 
							(userTypeUser === userType.Admin && item.status === statusLeaves.pending) || 
							(userTypeUser === userType.Administrative && myData.isSupervisor && item.status === statusLeaves.pending)
						"
						class="d-flex"
						:loading="submitLoading"
					>
						<v-btn
							@click="isAccept = true; leaveId = item.id; dialog = true"
							x-small 
							color="success white--text" 
							class="mx-2"
							:disabled="loading || submitLoading"
						>
							<v-icon small> mdi-check </v-icon>
						</v-btn>

						<v-btn
							@click="isAccept = false; leaveId = item.id; dialog = true"
							x-small
							color="alert-color white--text"
							:disabled="submitLoading || loading"
						>
							<v-icon small> mdi-close </v-icon>
						</v-btn>
					</div>
					</div>
				</template>

				<template v-slot:item.actions="{ item }">
					<div>
						<v-btn
							@click="leaveId = item.id; isOnlyShow = true; logLeaveUserId()"
							icon
							color="success"
						>
							<v-icon> mdi-eye </v-icon>
						</v-btn>

						<v-btn
							@click="leaveId = item.id; isOnlyShow = false; logLeaveUserId()"
							icon
							color="edit-color"
						>
							<v-icon> mdi-pencil </v-icon>
						</v-btn>

						<v-btn
							@click="leaveId = item.id; deleteDialog = true"
							icon
							color="alert-color"
						>
							<v-icon> mdi-delete </v-icon>
						</v-btn>
					</div>
				</template>

				<template v-slot:item.createdAt="{ item }">
					<span>
						{{ moment(item.createdAt).format('dddd') }}
						<br />
						{{ moment(item.createdAt)?.format('DD MMM YYYY') }}
					</span>
				</template>

				<template v-slot:item.fromDate="{ item }">
					<span>
						{{ moment(item.fromDate).format('dddd') }}
						<br />
						{{ moment(item.fromDate)?.format('DD MMM YYYY') }}
					</span>
				</template>

				<template v-slot:item.toDate="{ item }">
					<span>
						{{ moment(item.toDate).format('dddd') }}
						<br />
						{{ moment(item.toDate)?.format('DD MMM YYYY') }}
					</span>
				</template>
			</bee-handy-table>
			<!-- Dialog icons -->
			<div>
				<v-dialog
					v-model="dialog"
					max-width="350"
				>
					<v-card>
						<v-card-title class="">Confirmation</v-card-title>
						<v-card-text class="pb-0">
							<v-text-field 
								v-if="myData.isSupervisor"
								v-model="comment"
								dense
								hide-details
								filled
								label="Comment supervisor"
								solo
								class="rounded-lg input"
								prepend-icon="mdi-hours-12"
							/>
							<div class="mt-2">
								<span >
									Are you sure you want to proceed?
								</span>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								@click="acceptOrRejectLeave()"
								color="green darken-1 white--text"
								class="text-none rounded-lg"
								:loading="submitLoading"
							>
								Yes
							</v-btn>
							<v-btn
								@click="dialog = false"
								color="red darken-1 white--text"
								class="text-none rounded-lg"
								:disabled="submitLoading"
							>
								No
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				
				<!-- dialog -->
				<LeavesDialog
					:dialog.sync="adjustDialog"
					:leaveData="selectedLeave"
					@submit="updateLeave"
					@close="adjustDialog = false" 
					:leaveId="leaveId"
					:isOnlyShow="isOnlyShow"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import LeavesDialog from '@/components/Leaves/LeavesDialog.vue';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex'
import { statusLeaves, userType } from '@/helper/enum'

export default {
	components: {
		LeavesDialog
	},

	watch: {
		adjustDialog (val) {
			if (!val) {
				this.leaveId = null
				this.isOnlyShow = false
			}
		},
		dialog (val) {
			if (!val) {
				this.comment = null
			}
		}
	},

	data () {
		// const today = new Date(); 
		// const oneMonthAgo = new Date(); 
		// oneMonthAgo.setMonth(today.getMonth() - 1);
		return {
			menu: false,
			defaultLabel: 'From',
			defaultToLabel: 'To',
			dialog: false,
			action: null, 
			selectedItem: null,
			// fromDate: today.toISOString().substr(0, 10),
			// toDate: oneMonthAgo.toISOString().substr(0, 10),
			fromDate: null,
			toDate: null,
			dateWithYearsOver: null,
			hideDetails: false,
			selectedEmployeeId: null,
			serverItemsLength: 0,
			needResetShownRows: false,
			optionsScroll: {},
			deleteDialog: false,
			adjustDialog: false,
			selectedLeave: null, // Hold selected leave data
			statusLeaves,
			leaveId: null,
			isAccept: null,
			submitLoading: false,
			loading: false,
			hours: 0,
			seconds: 0,
			minutes: 0,
			isOnlyShow: false,
			comment: null,
			userType
		};
	},

	methods: {
		moment,
		deleteLeave () {
			this.submitLoading = true
			this.$store.dispatch('leaves/delete', { id: this.leaveId }).then(() => {
				this.needResetShownRows = true
				this.fetchAll()
				this.deleteDialog = false
			}).finally(() => {
				this.submitLoading = false
			})	
		},
		// selectPerson (person) {
		// 	this.selectedEmployeeId = person.name;
		// 	this.menu = false
		// },
		// plus (item) {
		// 	this.hours = item.createdAt.split('T')[1].split(':')[0]
		// 	setInterval(() => {
		// 		this.hours = parseInt(this.hours) + 1
		// 		return this.hours
		// 	}, 1000)
		// },
		// startTimer () { 
		// timer: { 
		// 			stat: { hours: '04', minutes: '12', seconds: '13' }, 
		// 			done: 'done',
		// 			text: '2h 32m'
		// 		},
		// 	this.leavesFD.forEach((item) => { 
		// 		let totalSeconds = parseInt(item.timer.stat.hours) * 3600 + parseInt(item.timer.stat.minutes) * 60 + parseInt(item.timer.stat.seconds); 
		// 		item.timer.interval = setInterval(() => { 
		// 			totalSeconds++; item.timer.stat.seconds = String(totalSeconds % 60).padStart(2, '0'); 
		// 			item.timer.stat.minutes = String(Math.floor(totalSeconds / 60) % 60).padStart(2, '0');
		// 			item.timer.stat.hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0'); 
		// 		}, 1000); 
		// 	}); 
		// }, 
		// approveItem (item) { 
		// 	clearInterval(item.timer.interval); 
		// 	item.timer.done = 'done'; 
		// 	item.timer.text = this.formatTime(item.timer.stat.hours, item.timer.stat.minutes); 
		// 	item.status.stat = 'done'; 
		// 	item.status.value = 'Approved';
		// },
		// rejectItem (item) { 
		// 	clearInterval(item.timer.interval); 
		// 	item.timer.done = 'done'; 
		// 	item.timer.text = this.formatTime(item.timer.stat.hours, item.timer.stat.minutes); 
		// 	item.status.stat = 'done'; 
		// 	item.status.value = 'Rejected'; 
		// },
		// formatTime (hours, minutes) { 
		// 	return `${parseInt(hours)}h ${parseInt(minutes)}m`; 
		// },
		// showDialog (action, item) { 
		// 	this.action = action; this.selectedItem = item; this.dialog = true; 
		// },
		// confirmAction () {
		// 	this.dialog = false; 
		// 	if (this.action === 'approve') {
		// 		this.approveItem(this.selectedItem); 
		// 	} else if (this.action === 'reject') {
		// 		this.rejectItem(this.selectedItem); 
		// 	} 
		// },
		// API work
		// ...mapActions('leaves', ['fetchEmployees', 'fetchById']),
		fetchEmployeeDetails () {
			if (this.selectedEmployeeId) {
				this.$store.dispatch('leaves/fetchAll', { employeeIds: [this.selectedEmployeeId] }).then(data => {
					console.log('Fetched Employee Details', data);
				}).catch(error => {
					console.error('Error Fetching Employee Details', error);
				});
			}
		},

		// important one

		// logLeaveUserId (leave) { 
		// 	console.log('User ID associated with this leave:', leave.userId);
		// },
		// logLeaveId (leave) {
		// 	console.log('Selected Leave ID:', leave.id); 
		// },
		logLeaveUserId () { 
			console.log('User ID associated with this leave:');
			this.adjustDialog = true
		},
		logLeaveId () {
			console.log('Selected Leave ID:'); 
			this.deleteDialog = true
		},
		updateLeave (data) { 
			this.$store.dispatch('leaves/update', { ...data, id: this.leaveId }).then(() => { 
				this.adjustDialog = false;
			}).catch(error => { 
				console.error('Error updating leave:', error);
			}); 
		},

		fetchAll (newOptionsScroll, isFirstLoad = false) {
			this.loading = true
			let page = 1;
			if (newOptionsScroll) {
				page = newOptionsScroll.page
			}
			return this.$store.dispatch('leaves/fetchAll', {
				page: page,
				perPage: 20,
				employeeIds: this.selectedEmployeeId ? [this.selectedEmployeeId] : [], 
				fromDate: this.fromDate, 
				toDate: this.toDate
			}).then((data) => {
				if (this.needResetShownRows === true) {
					this.$refs.table.resetShownRows()
				}
				this.$refs.table.addScrollItems(data.data)
				this.serverItemsLength = data.total
			}).finally(() => {
				if (!isFirstLoad) this.loading = false
				this.needResetShownRows = false
			})
		},

		acceptOrRejectLeave () {
			this.submitLoading = true
			const actionName = this.myData.isSupervisor ? 'supervisorAccept' : this.userTypeUser === userType.Admin ? 'administratorAccept' : null
			this.$store.dispatch(`leaves/${actionName}`, { 
				id: this.leaveId, 
				isAccept: this.isAccept,
				acceptance: actionName === 'supervisorAccept' ? this.isAccept : null,
				comment: actionName === 'supervisorAccept' ? this.comment : null
			}).then(() => {
				this.submitLoading = false
				this.leaveId = null
				this.isAccept = null	
				this.dialog = false
				this.needResetShownRows = true
				this.fetchAll()
			}).catch(() => {
				this.submitLoading = false
				this.leaveId = null
				this.isAccept = null
			})
		}

	},
	mounted () {
		// this.startTimer();
	},
	computed: {
		headers () {
			const headers = [
				{
					text: 'Employee',	
					name: 'userId',
					value: 'userId',
					setValueExpr: val => this.employees.find(c => c.id === val)?.employee.arabicFirstName + ' ' + this.employees.find(c => c.id === val)?.employee.arabicLastName,
					align: 'start',
					sortable: false
				},
				{
					text: 'Created at', 
					name: 'createdAt',
					value: 'createdAt',
					// setValueExpr: val => moment(val).format('dddd') + '  ' + moment(val)?.format('DD MMM YYYY'),
					sortable: false
				},
				{
					text: 'Start', 
					name: 'fromDate',
					value: 'fromDate',
					// setValueExpr: val => moment(val).format('dddd') + '  ' + moment(val)?.format('DD MMM YYYY'),
					sortable: false
				},
				{
					text: 'End', 
					name: 'toDate',
					value: 'toDate',
					// setValueExpr: val => moment(val)?.format('DD MMM YYYY'),
					sortable: false
				},
				{ 
					text: 'Days', 
					name: 'durationInDays',
					value: 'durationInDays',
					sortable: false
					// width: '25px'
				},
				{ 
					text: 'Hours',
					name: 'durationInMinute',
					value: 'durationInMinute',
					setValueExpr: val => val !== null ? (val / 60).toFixed(2) : '-',
					noNotAvailableText: true,
					// width: '82px',
					sortable: false
				},
				{ 
					text: 'Reason',
					name: 'reason', 
					value: 'reason',
					sortable: false,
					width: '30%'
				},
				// { 
				// 	text: 'Timer', 
				// 	sortable: false,
				// 	value: 'createdAt',
				// 	name: 'createdAt',
				// 	setValueExpr: (val) => { 
				// 		const time = val?.split('T')[1].split(':')
				// 		const timer = {
				// 			hours: time[0],
				// 			minutes: time[1],
				// 			seconds: time[2]
				// 		}
				// 		return timer
		
				// 		// let totalSeconds = parseInt(timer.hours) * 3600 + parseInt(timer.minutes) * 60 + parseInt(timer.seconds); 
				// 		// timer.interval = setInterval(() => { 
				// 		// 	totalSeconds++; 
				// 		// 	timer.seconds = String(totalSeconds % 60).padStart(2, '0'); 
				// 		// 	timer.minutes = String(Math.floor(totalSeconds / 60) % 60).padStart(2, '0');
				// 		// 	timer.hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0'); 
				// 		// }, 1000); 
				// 		// return timer
				// 	},
				// 	width: '105px',
				// 	class: 'px-1',
				// 	cellClass: 'px-0'
				// },

				this.userTypeUser === userType.Admin 
					? { 
						text: 'Supervisor Acceptance', 
						value: 'supervisorAcceptance',
						name: 'supervisorAcceptance',
						sortable: false,
						width: '300px'
					} 
					: null,
				{ 
					text: 'Status', 
					name: 'status',
					value: 'status',
					sortable: false,
					width: '300'
				}
				// { 
				// 	text: '', 
				// 	value: 'actions', 
				// 	name: 'actions',
				// 	sortable: false,
				// 	align: 'end',
				// 	width: '160px'
				// }
			]
			return headers.filter(c => c !== null)
		},
		// API Work 
		...mapState({
			leaves: state => state.leaves.leaves,
			employees: state => state.users.usersWithoutPag,
			statics: state => state.leaves.statics,
			userTypeUser: state => state.auth.self.userType,
			myData: state => state.users.myData
		}),
		...mapGetters({
			getLeavesById: 'leaves/getLeavesById',
			getEmployeeById: 'users/getEmployeeById'
		}),
		//
		formattedLabel () { 
			return this.fromDate ? moment(this.fromDate).format('dddd') : this.defaultLabel; 
		},
		formattedToDateLabel () { 
			return this.toDate ? moment(this.toDate).format('dddd') : this.defaultToLabel; 
		}
	},
	created () {
		this.loading = true
		this.needResetShownRows = true
		Promise.all([
			this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true }),
			this.$store.dispatch('leaves/fetchStatics')
		]).then(() => {
			this.fetchAll(null, true)
		}).finally(() => {
			this.loading = false
		})
	}
}
</script>
<style scoped>
</style>
